module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "Ded"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PHILEMON")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "Ded1"
  }, [_vm._v("“Pastor, what do you think would have happened"), _c('br'), _vm._v("if a runaway slave in America"), _c('br'), _vm._v("had carried this letter back to his master?”")]), _vm._v(" "), _c('p', {
    staticClass: "Ded2"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(" A. N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OEL")])]), _vm._v(" "), _c('p', {
    staticClass: "Ded3"
  }, [_vm._v("Onesimus Our Brother, 5")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb6c9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0